// extracted by mini-css-extract-plugin
export var emailBlockLink = "_px-0";